module.exports = __webpack_public_path__ + "media/images/front/toppage_cc_1-56ce852b5dfc523016ae52909dd7fd04.jpg";